// Thin typed loader for contracts/templates/example-rooms.json (onboarding only).
// Landing showcase rooms live in contracts/templates/landing-rooms.json.
//
// Two snapshots are stored per id (`bare` / `treated`). This module
// exports the wizard default (`wizardVariant` in the JSON — flip there).
import type { EditorDoc, TemplateVariant } from '@roomtreatment/core';
import seedData from '../../../../../../contracts/templates/example-rooms.json';

export interface ExampleRoom {
  id: string;
  name: string;
  blurb: string;
  doc: EditorDoc;
}

interface SeedFile {
  solverEpoch: string;
  wizardVariant: TemplateVariant;
  rooms: { id: string; name: string; blurb: string; doc: EditorDoc }[];
}

const seed = seedData as unknown as SeedFile;

/** Which snapshot the wizard "Use example" path hydrates.
 *  Flip `wizardVariant` in contracts/templates/example-rooms.json. */
export const WIZARD_TEMPLATE_VARIANT: TemplateVariant = seed.wizardVariant ?? 'bare';

/** Seed doc as the wizard should land it when the snapshot isn't ready
 *  (live-solve fallback). Strips panels when the wizard default is bare. */
export function wizardFallbackDoc(doc: EditorDoc): EditorDoc {
  return WIZARD_TEMPLATE_VARIANT === 'bare' ? { ...doc, panels: [] } : doc;
}

export const ONBOARDING_EXAMPLE_ROOMS: ExampleRoom[] = seed.rooms.map((r) => ({
  id: r.id,
  name: r.name,
  blurb: r.blurb,
  doc: r.doc,
}));
